$shm_hitalama_contextmenu $mol_view
	sub /
		<= Body $mol_list
			sub <= body /
	plugins /
		^
		<= Hovered $shm_hitalama_hovered
			hovered? <=> hovered? false
	pos? /
		0
		0
	show? null
	style *
		left <= left? \0px
		top <= top? \0px
	event *
		pointerenter? <=> pointerenter? null
		pointerleave? <=> pointerleave? null
	showed? false
	auto /
		<= pointerdown_listener $shm_listener /
			\pointerdown
			<= pointerdown_handler null
			<= document null
			true
